import arLocale from 'element-ui/lib/locale/lang/ar'
import home from './ar/home'

const ar = {
    language: 'العربية',
    message: {
        'home': home,
    },
    '手机号码最小长度为8位': 'الحد الأدنى لطول رقم الهاتف المحمول هو 8 أرقام',
    '邮箱账号名称最小长度为6位': 'الحد الأدنى لطول اسم حساب البريد الإلكتروني هو 6 أحرف',
    '邮箱只能包含英文，数字等字符': 'يمكن أن يحتوي صندوق البريد فقط على اللغة الإنجليزية والأرقام والأحرف الأخرى',
    '请选择正确的收货地址': 'الرجاء تحديد عنوان التسليم الصحيح',
    ...arLocale
}
export default ar